// src/services/tokenFetcher/taraxaTokenFetcher.js
import secureFetch from '../../utils/secureFetch';

/**
 * Fetch tokens for a Taraxa wallet using the Taraxa API.
 *
 * @param {string} walletAddress - The wallet address to query
 * @returns {Promise<Array>} - A promise that resolves to an array of token objects
 */
export const fetchTokens = async (walletAddress) => {
  try {
    const response = await secureFetch(`https://tara.to/api/v2/addresses/${walletAddress}/token-balances`);
    
    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}: ${response.statusText}`);
    }
    
    const data = await response.json();
    return data; // API returns an array directly
  } catch (error) {
    console.error("Error fetching Taraxa tokens:", error);
    return [];
  }
};